// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"873":"9cd77a06","979":"9b69a7ca"}[chunkId] + ".js";
};